import { useT } from "@transifex/react";
import ExerciseStarterText from "../exerciseStarterText/ExerciseStarterText";
import useBreakpoints, { Breakpoint } from "../../../../../../hooks/useBreakpoints";
import StyledButtonWithIcon from "../../../../../../basic/styledButtonWithIcon/StyledButtonWithIcon";

export interface FreeTextHeaderActionsProps {
    onClickAddVocabularyButton: () => void;
    isSelectExerciseVocabularyOpen: boolean;
}

const FreeTextHeaderActions = (props: FreeTextHeaderActionsProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const t = useT();
    const t_vocabulary = t("Vocabulary", { _tags: "CreateTest,ExerciseDetails" });

    return (
        <div
            className={`flex flex-wrap gap-s ${getStyleBasedOnBreakpoint(
                Breakpoint.MD,
                "flex-row items-start",
                "flex-col items-stretch"
            )}`}
        >
            {!props.isSelectExerciseVocabularyOpen && (
                <StyledButtonWithIcon
                    className={getStyleBasedOnBreakpoint(Breakpoint.MD, "self-start w-auto", "self-stretch w-full")}
                    data-testid="button-add-vocabulary"
                    buttonStyle={"LIGHT_BORDER"}
                    icon={"add"}
                    iconPosition={"LEFT"}
                    onClick={props.onClickAddVocabularyButton}
                >
                    {t_vocabulary}
                </StyledButtonWithIcon>
            )}
            <ExerciseStarterText />
        </div>
    );
};

export default FreeTextHeaderActions;
